import { Component, OnInit } from '@angular/core';
import { PurchaseService } from '../../../services/purchase.service';
import { Trip } from '../../../models/trip.model';
import { Router } from '@angular/router';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-times',
  templateUrl: './times.component.html',
  styleUrls: ['./times.component.scss']
})
export class TimesComponent implements OnInit {

  faCheck = faCheck;

  trips: Trip[];

  groups: {
    dateKey: string,
    date: Date,
    trips: Trip[],
    selected: Trip,
  }[];

  route: any;

  constructor(
    private purchaseService: PurchaseService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.purchaseService.checkStepAndNavigateIfInvalid('dates');

    this.trips = this.purchaseService.get('dates').trips;

    this.route = this.purchaseService.get('route');

    this.groups = [];

    this.trips.forEach((trip) => {
      const dateKey = trip.date.split('T')[0];

      let existingGroup = this.groups.find(group => group.dateKey === dateKey);
      if (!existingGroup) {
        existingGroup = {
          dateKey,
          date: new Date(trip.date),
          trips: [],
          selected: null
        };
        this.groups.push(existingGroup);
      }

      existingGroup.trips.push(trip);

      if (!existingGroup.selected) {
        existingGroup.selected = trip;
      }
    });
  }

ok(): void {
  const selectedTrips = this.groups
    .map(group => group.selected)
    .filter(trip => trip !== null);

  if (selectedTrips.length === 0) {
    console.warn('No trip selected');
    return;
  }

  this.purchaseService.set('times', selectedTrips);

  console.log('trips to buy', selectedTrips);

  this.router.navigate(['steps/checkout']);
}


}
